import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, loginWithRedirect, } = useAuth0();
  
  const isAuth0Enabled = import.meta.env.VITE_AUTH0_ENABLED === 'true';

  useEffect(() => {
    if (isAuth0Enabled && !isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, isAuth0Enabled]);

  if (isAuth0Enabled && isLoading) {
    return <div>Loading...</div>;
  }

  return (isAuth0Enabled && isAuthenticated) || !isAuth0Enabled ? <Outlet /> : null;
};

export default ProtectedRoute;
